import React, { createContext, useContext, useMemo, useState } from 'react';

const UserCourseContext = createContext({
  courseName: '',
  setCourseName: () => {},
});

export function UserCourseProvider({ children }) {
  const [courseName, setCourseName] = useState('');
  const value = useMemo(() => ({ courseName, setCourseName }), [courseName]);

  return (
    <UserCourseContext.Provider value={value}>
      {children}
    </UserCourseContext.Provider>
  );
}

export function useUserCourse() {
  return useContext(UserCourseContext);
}
